/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../../base';
// @ts-ignore
import type { GetDecodeInternalServerErrDto } from '../../src/model';
// @ts-ignore
import type { PostDecodeInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { PostDecodeReqBodyDto } from '../../src/model';
// @ts-ignore
import type { PostEncodeCreatedDto } from '../../src/model';
// @ts-ignore
import type { PostEncodeInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { PostEncodeReqBodyDto } from '../../src/model';
/**
 * NiceApi - axios parameter creator
 * @export
 */
export const NiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary nice에서 호출: 복호화 후 인증 데이터와 함께 리다이렉트(PC: GET)
         * @param {string} redirectUrl 인증 결과를 전달받을 URL
         * @param {string} encodeData 암호화된 데이터(nice에서 파스칼 케이스로 넘겨줌)
         * @param {NiceControllerGetDecodeDecodeModeEnum} decodeMode 인증 모드
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        niceControllerGetDecode: async (redirectUrl: string, encodeData: string, decodeMode: NiceControllerGetDecodeDecodeModeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'redirectUrl' is not null or undefined
            assertParamExists('niceControllerGetDecode', 'redirectUrl', redirectUrl)
            // verify required parameter 'encodeData' is not null or undefined
            assertParamExists('niceControllerGetDecode', 'encodeData', encodeData)
            // verify required parameter 'decodeMode' is not null or undefined
            assertParamExists('niceControllerGetDecode', 'decodeMode', decodeMode)
            const localVarPath = `/nice/decrypt/{decodeMode}`
                .replace(`{${"decodeMode"}}`, encodeURIComponent(String(decodeMode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (redirectUrl !== undefined) {
                localVarQueryParameter['redirectUrl'] = redirectUrl;
            }

            if (encodeData !== undefined) {
                localVarQueryParameter['EncodeData'] = encodeData;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary nice에서 호출: 복호화 후 인증 데이터와 함께 리다이렉트(mobile: POST)
         * @param {string} redirectUrl 인증 결과를 전달받을 URL
         * @param {NiceControllerPostDecodeDecodeModeEnum} decodeMode 인증 모드
         * @param {PostDecodeReqBodyDto} postDecodeReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        niceControllerPostDecode: async (redirectUrl: string, decodeMode: NiceControllerPostDecodeDecodeModeEnum, postDecodeReqBodyDto: PostDecodeReqBodyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'redirectUrl' is not null or undefined
            assertParamExists('niceControllerPostDecode', 'redirectUrl', redirectUrl)
            // verify required parameter 'decodeMode' is not null or undefined
            assertParamExists('niceControllerPostDecode', 'decodeMode', decodeMode)
            // verify required parameter 'postDecodeReqBodyDto' is not null or undefined
            assertParamExists('niceControllerPostDecode', 'postDecodeReqBodyDto', postDecodeReqBodyDto)
            const localVarPath = `/nice/decrypt/{decodeMode}`
                .replace(`{${"decodeMode"}}`, encodeURIComponent(String(decodeMode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (redirectUrl !== undefined) {
                localVarQueryParameter['redirectUrl'] = redirectUrl;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postDecodeReqBodyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 암호화 데이터 생성
         * @param {PostEncodeReqBodyDto} postEncodeReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        niceControllerPostEncode: async (postEncodeReqBodyDto: PostEncodeReqBodyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postEncodeReqBodyDto' is not null or undefined
            assertParamExists('niceControllerPostEncode', 'postEncodeReqBodyDto', postEncodeReqBodyDto)
            const localVarPath = `/nice/encrypt`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postEncodeReqBodyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NiceApi - functional programming interface
 * @export
 */
export const NiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary nice에서 호출: 복호화 후 인증 데이터와 함께 리다이렉트(PC: GET)
         * @param {string} redirectUrl 인증 결과를 전달받을 URL
         * @param {string} encodeData 암호화된 데이터(nice에서 파스칼 케이스로 넘겨줌)
         * @param {NiceControllerGetDecodeDecodeModeEnum} decodeMode 인증 모드
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async niceControllerGetDecode(redirectUrl: string, encodeData: string, decodeMode: NiceControllerGetDecodeDecodeModeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.niceControllerGetDecode(redirectUrl, encodeData, decodeMode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NiceApi.niceControllerGetDecode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary nice에서 호출: 복호화 후 인증 데이터와 함께 리다이렉트(mobile: POST)
         * @param {string} redirectUrl 인증 결과를 전달받을 URL
         * @param {NiceControllerPostDecodeDecodeModeEnum} decodeMode 인증 모드
         * @param {PostDecodeReqBodyDto} postDecodeReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async niceControllerPostDecode(redirectUrl: string, decodeMode: NiceControllerPostDecodeDecodeModeEnum, postDecodeReqBodyDto: PostDecodeReqBodyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.niceControllerPostDecode(redirectUrl, decodeMode, postDecodeReqBodyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NiceApi.niceControllerPostDecode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 암호화 데이터 생성
         * @param {PostEncodeReqBodyDto} postEncodeReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async niceControllerPostEncode(postEncodeReqBodyDto: PostEncodeReqBodyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostEncodeCreatedDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.niceControllerPostEncode(postEncodeReqBodyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NiceApi.niceControllerPostEncode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NiceApi - factory interface
 * @export
 */
export const NiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NiceApiFp(configuration)
    return {
        /**
         * 
         * @summary nice에서 호출: 복호화 후 인증 데이터와 함께 리다이렉트(PC: GET)
         * @param {NiceApiNiceControllerGetDecodeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        niceControllerGetDecode(requestParameters: NiceApiNiceControllerGetDecodeRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.niceControllerGetDecode(requestParameters.redirectUrl, requestParameters.encodeData, requestParameters.decodeMode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary nice에서 호출: 복호화 후 인증 데이터와 함께 리다이렉트(mobile: POST)
         * @param {NiceApiNiceControllerPostDecodeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        niceControllerPostDecode(requestParameters: NiceApiNiceControllerPostDecodeRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.niceControllerPostDecode(requestParameters.redirectUrl, requestParameters.decodeMode, requestParameters.postDecodeReqBodyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 암호화 데이터 생성
         * @param {NiceApiNiceControllerPostEncodeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        niceControllerPostEncode(requestParameters: NiceApiNiceControllerPostEncodeRequest, options?: RawAxiosRequestConfig): AxiosPromise<PostEncodeCreatedDto> {
            return localVarFp.niceControllerPostEncode(requestParameters.postEncodeReqBodyDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for niceControllerGetDecode operation in NiceApi.
 * @export
 * @interface NiceApiNiceControllerGetDecodeRequest
 */
export interface NiceApiNiceControllerGetDecodeRequest {
    /**
     * 인증 결과를 전달받을 URL
     * @type {string}
     * @memberof NiceApiNiceControllerGetDecode
     */
    readonly redirectUrl: string

    /**
     * 암호화된 데이터(nice에서 파스칼 케이스로 넘겨줌)
     * @type {string}
     * @memberof NiceApiNiceControllerGetDecode
     */
    readonly encodeData: string

    /**
     * 인증 모드
     * @type {'register' | 'findId' | 'resetPassword' | 'addCi' | 'reAuthentication'}
     * @memberof NiceApiNiceControllerGetDecode
     */
    readonly decodeMode: NiceControllerGetDecodeDecodeModeEnum
}

/**
 * Request parameters for niceControllerPostDecode operation in NiceApi.
 * @export
 * @interface NiceApiNiceControllerPostDecodeRequest
 */
export interface NiceApiNiceControllerPostDecodeRequest {
    /**
     * 인증 결과를 전달받을 URL
     * @type {string}
     * @memberof NiceApiNiceControllerPostDecode
     */
    readonly redirectUrl: string

    /**
     * 인증 모드
     * @type {'register' | 'findId' | 'resetPassword' | 'addCi' | 'reAuthentication'}
     * @memberof NiceApiNiceControllerPostDecode
     */
    readonly decodeMode: NiceControllerPostDecodeDecodeModeEnum

    /**
     * 
     * @type {PostDecodeReqBodyDto}
     * @memberof NiceApiNiceControllerPostDecode
     */
    readonly postDecodeReqBodyDto: PostDecodeReqBodyDto
}

/**
 * Request parameters for niceControllerPostEncode operation in NiceApi.
 * @export
 * @interface NiceApiNiceControllerPostEncodeRequest
 */
export interface NiceApiNiceControllerPostEncodeRequest {
    /**
     * 
     * @type {PostEncodeReqBodyDto}
     * @memberof NiceApiNiceControllerPostEncode
     */
    readonly postEncodeReqBodyDto: PostEncodeReqBodyDto
}

/**
 * NiceApi - object-oriented interface
 * @export
 * @class NiceApi
 * @extends {BaseAPI}
 */
export class NiceApi extends BaseAPI {
    /**
     * 
     * @summary nice에서 호출: 복호화 후 인증 데이터와 함께 리다이렉트(PC: GET)
     * @param {NiceApiNiceControllerGetDecodeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NiceApi
     */
    public niceControllerGetDecode(requestParameters: NiceApiNiceControllerGetDecodeRequest, options?: RawAxiosRequestConfig) {
        return NiceApiFp(this.configuration).niceControllerGetDecode(requestParameters.redirectUrl, requestParameters.encodeData, requestParameters.decodeMode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary nice에서 호출: 복호화 후 인증 데이터와 함께 리다이렉트(mobile: POST)
     * @param {NiceApiNiceControllerPostDecodeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NiceApi
     */
    public niceControllerPostDecode(requestParameters: NiceApiNiceControllerPostDecodeRequest, options?: RawAxiosRequestConfig) {
        return NiceApiFp(this.configuration).niceControllerPostDecode(requestParameters.redirectUrl, requestParameters.decodeMode, requestParameters.postDecodeReqBodyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 암호화 데이터 생성
     * @param {NiceApiNiceControllerPostEncodeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NiceApi
     */
    public niceControllerPostEncode(requestParameters: NiceApiNiceControllerPostEncodeRequest, options?: RawAxiosRequestConfig) {
        return NiceApiFp(this.configuration).niceControllerPostEncode(requestParameters.postEncodeReqBodyDto, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const NiceControllerGetDecodeDecodeModeEnum = {
    Register: 'register',
    FindId: 'findId',
    ResetPassword: 'resetPassword',
    AddCi: 'addCi',
    ReAuthentication: 'reAuthentication'
} as const;
export type NiceControllerGetDecodeDecodeModeEnum = typeof NiceControllerGetDecodeDecodeModeEnum[keyof typeof NiceControllerGetDecodeDecodeModeEnum];
/**
 * @export
 */
export const NiceControllerPostDecodeDecodeModeEnum = {
    Register: 'register',
    FindId: 'findId',
    ResetPassword: 'resetPassword',
    AddCi: 'addCi',
    ReAuthentication: 'reAuthentication'
} as const;
export type NiceControllerPostDecodeDecodeModeEnum = typeof NiceControllerPostDecodeDecodeModeEnum[keyof typeof NiceControllerPostDecodeDecodeModeEnum];
